/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {DrivingLevelsService} from "../../services/driving-levels.service";
import {DrivingLevel} from "../../model/DrivingLevel";
import {NgxSpinnerService} from 'ngx-spinner';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-driving-level',
    templateUrl: './driving-level.component.html',
    styleUrls: ['./driving-level.component.less'],
    standalone: false
})
export class DrivingLevelComponent extends BaseMessageComponent implements OnInit {
  public _drivingLevels: DrivingLevel[];
  public indexWithChanges: number[] = [];

  constructor(private driverLevelService: DrivingLevelsService,
              private spinnerService: NgxSpinnerService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllDriverLevels();
  }

  getAllDriverLevels(): void {
    this.spinnerService.show();
    this._drivingLevels = [];
    this.indexWithChanges = [];
    this.driverLevelService.getAllDrivingLevels().subscribe( value => {
        this._drivingLevels = value;
        this.cdr.detectChanges();
      },
      err => {
        console.log(err);
        alert(err);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  addNew(name: string, desc: string) {
    if (name.trim() == "" || desc.trim() == "") {
      alert("Please add name and description before saving a new record.");
    } else {
      this.spinnerService.show();
      var newDrivingLevel = new DrivingLevel();
      newDrivingLevel.drivingLevelName = name;
      newDrivingLevel.description = desc;
      newDrivingLevel.active = true;

      this.driverLevelService.addNew(newDrivingLevel).subscribe(value => {
          //success
          this._drivingLevels = null;
          this.getAllDriverLevels();
        }, (error) => {
          //failed
          console.error(error);
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        });
    }
  }

  updateIndexes(index) {
    if(this.indexWithChanges.indexOf(index)===-1){
      this.indexWithChanges.push(index);
    }
    console.log(this.indexWithChanges);
  }

  saveChanges() {
    if(this.indexWithChanges.length > 0) {
      for (var i = 0; i < this.indexWithChanges.length; i++) {
        var idx = this.indexWithChanges[i];
        this.driverLevelService.updateTrainingCourse(this._drivingLevels[idx]).subscribe(value => {
            console.log(this._drivingLevels[idx] + " saved.")
          }, (error) => {
            //failed
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
          },
          () => {
            this.indexWithChanges = [];
          });
      }
      setTimeout(() => {
        this.getAllDriverLevels();
      }, 3000);
    } else {
      alert("No changes to save.");
    }
  }
}
